import React, { useState, useEffect } from 'react';
import { PageHeader, Card, Btn } from '../../components/UI';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const STATES = ['Tamil Nadu','Andhra Pradesh','Karnataka','Kerala','Maharashtra','Delhi','Gujarat','Rajasthan','Uttar Pradesh','West Bengal','Other','Outside India'];

export default function Profile() {
  const [profile, setProfile] = useState({ name: '', company_name: '', phone: '', address: '', state: 'Tamil Nadu', gstin: '' });
  const [pwd, setPwd] = useState({ current_password: '', new_password: '', confirm: '' });
  const [history, setHistory] = useState([]);
  const [saving, setSaving] = useState(false);
  const [changing, setChanging] = useState(false);

  useEffect(() => {
    api.get('/api/users/profile').then(r => { if (r.data.success) { const u = r.data.user; setProfile({ name: u.name || '', company_name: u.company_name || '', phone: u.phone || '', address: u.address || '', state: u.state || 'Tamil Nadu', gstin: u.gstin || '' }); } });
    api.get('/api/users/login-history').then(r => { if (r.data.success) setHistory(r.data.history); });
  }, []);

  const saveProfile = async () => {
    setSaving(true);
    const { data } = await api.put('/api/users/profile', profile);
    if (data.success) toast.success('Profile updated!');
    else toast.error(data.message);
    setSaving(false);
  };

  const changePwd = async () => {
    if (!pwd.current_password || !pwd.new_password) { toast.error('Fill all fields'); return; }
    if (pwd.new_password !== pwd.confirm) { toast.error('Passwords do not match'); return; }
    if (pwd.new_password.length < 8) { toast.error('Password must be at least 8 characters'); return; }
    setChanging(true);
    const { data } = await api.put('/api/users/change-password', { current_password: pwd.current_password, new_password: pwd.new_password });
    if (data.success) { toast.success('Password changed!'); setPwd({ current_password: '', new_password: '', confirm: '' }); }
    else toast.error(data.message);
    setChanging(false);
  };

  const field = (label, key, type = 'text', ph = '') => (
    <div key={key} style={{ marginBottom: 14 }}>
      <label style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 6, fontWeight: 500 }}>{label}</label>
      <input type={type} value={profile[key]} onChange={e => setProfile({ ...profile, [key]: e.target.value })} placeholder={ph} style={{ width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 14px', color: 'var(--text)', fontSize: 14 }} />
    </div>
  );

  return (
    <div>
      <PageHeader title="Profile & Settings" />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        <Card title="👤 Company Details">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            {field('Full Name', 'name', 'text', 'Your name')}
            {field('Company Name', 'company_name', 'text', 'Company name')}
          </div>
          {field('Phone', 'phone', 'tel', '+91 9876543210')}
          {field('Address', 'address', 'text', 'Your address')}
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 6, fontWeight: 500 }}>State</label>
            <select value={profile.state} onChange={e => setProfile({ ...profile, state: e.target.value })} style={{ width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 14px', color: 'var(--text)', fontSize: 14 }}>
              {STATES.map(s => <option key={s}>{s}</option>)}
            </select>
          </div>
          {field('GST Number (Optional)', 'gstin', 'text', '22AAAAA0000A1Z5')}
          <Btn onClick={saveProfile} disabled={saving} full>{saving ? 'Saving...' : '💾 Save Profile'}</Btn>
        </Card>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <Card title="🔑 Change Password">
            {[['Current Password', 'current_password'], ['New Password', 'new_password'], ['Confirm New Password', 'confirm']].map(([label, key]) => (
              <div key={key} style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 6, fontWeight: 500 }}>{label}</label>
                <input type="password" value={pwd[key]} onChange={e => setPwd({ ...pwd, [key]: e.target.value })} placeholder={label} style={{ width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 14px', color: 'var(--text)', fontSize: 14 }} />
              </div>
            ))}
            <Btn variant="outline" onClick={changePwd} disabled={changing} full>{changing ? 'Changing...' : '🔑 Change Password'}</Btn>
          </Card>

          <Card title="🔐 Recent Login History">
            {history.length === 0 ? (
              <div style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 20, fontSize: 13 }}>No history yet</div>
            ) : history.slice(0, 6).map((h, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                <div>
                  <div>{h.status === 'success' ? '✅' : '❌'} {new Date(h.created_at).toLocaleString('en-IN')}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{h.ip_address || 'Unknown IP'}</div>
                </div>
                <span style={{ background: h.status === 'success' ? 'rgba(0,231,76,0.1)' : 'rgba(255,68,68,0.1)', color: h.status === 'success' ? 'var(--green)' : '#ff6b6b', padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 700 }}>{h.status?.toUpperCase()}</span>
              </div>
            ))}
          </Card>
        </div>
      </div>
    </div>
  );
}